const initialState = {
  byWidgetId: {}
};

const moadReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_MOAD_START':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            ...state.byWidgetId[action.payload.widgetId],
            loading: true,
            error: null
          }
        }
      };

    case 'FETCH_MOAD_SUCCESS':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            loading: false,
            error: null,
            data: action.payload.data
          }
        }
      };

    case 'FETCH_MOAD_FAILURE':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            ...state.byWidgetId[action.payload.widgetId],
            loading: false,
            error: action.payload.error
          }
        }
      };

    default:
      return state;
  }
};

export default moadReducer;
